import { render, staticRenderFns } from "./errors.vue?vue&type=template&id=40e44a3f"
import script from "./errors.js?vue&type=script&lang=js&external"
export * from "./errors.js?vue&type=script&lang=js&external"
import style0 from "./errors.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports